import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";

import Auth from "../pages/auth";
import DashboardAccountant from "../pages/dashboardAccountant";
import LoadedPayments from "../pages/loadedPayments";
import ActSverkaAccountant from "../pages/actSverkaAccountant";
import Recommendation from "../pages/recommendations";
import BankStatements from "../pages/bankStatements";
import ConversionAccountant from "../pages/conversionAccountant";
import ConversionAccountantUploaded from "../pages/conversionAccountantUploaded/index";

const ProtectedRoute = ({ element: Component, roles = [], ...rest }) => {
  const isAuthenticated = useSelector((state) => state.main.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  if (!roles) {
    return <Navigate to="/" replace />;
  }

  return <Component {...rest} />;
};

const RoutesComponent = () => {
  const isAuthenticated = useSelector((state) => state.main.isAuthenticated);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Navigate
            to={isAuthenticated ? "/dashboard-accountant" : "/auth"}
            replace
          />
        }
      />
      <Route path="/auth" element={<Auth />} />
      <Route
        path="/dashboard-accountant"
        // element={<DashboardAccountant />}
        element={<ProtectedRoute element={DashboardAccountant} />}
      />

      <Route
        path="/loaded-payments"
        // element={<LoadedPayments />}
        element={<ProtectedRoute element={LoadedPayments} />}
      />

      <Route
        path="/act-sverka-accountant"
        // element={<ActSverkaAccountant />}
        element={<ProtectedRoute element={ActSverkaAccountant} />}
      />
      <Route
        path="/act-sverka-accountant/:id"
        // element={<ActSverkaAccountant />}
        element={<ProtectedRoute element={ActSverkaAccountant} />}
      />
      <Route
        path="/loaded-payments/:id"
        // element={<LoadedPayments />}
        element={<ProtectedRoute element={LoadedPayments} />}
      />
      <Route
        path="/bank-statement/:id"
        // element={<BankStatements />}
        element={<ProtectedRoute element={BankStatements} />}
      />
      <Route
        path="/conversion-accountant/:id"
        // element={<ConversionAccountant />}
        element={<ProtectedRoute element={ConversionAccountant} />}
      />
      <Route
        path="/conversion-accountant-uploaded"
        // element={<ConversionAccountantUploaded />}
        element={<ProtectedRoute element={ConversionAccountantUploaded} />}
      />
      <Route
        path="/recommendation"
        // element={<Recommendation />}
        element={<ProtectedRoute element={Recommendation} />}
      />
    </Routes>
  );
};

export default RoutesComponent;
